export class Opcao {
  id: number;
  nome: string;
  selected?: boolean;
}
